import {upsert, setFetchingForView, setMetaProp, setView, setCurrent, setComplete} from '../../../helpers'

export default {
  setFetchingForView,
  setMetaProp,
  setView,
  setCurrent,
  upsert,
  setComplete
}



// WEBPACK FOOTER //
// ./src/store/modules/modules/mutations.js